// Copyright 2022-2025 - Hewlett Packard Enterprise Company

import { Spinner } from 'grommet';

const LoadingSpinner = ({ message, ...rest }) => (
  <Spinner message={message || 'Loading'} {...rest} />
);

export default LoadingSpinner;
